import { useMedia } from "react-use";
import { MOBILE_MAX_WIDTH } from "../../../constant";

type Props = {
  text: string;
  isActive: boolean;
  onClick: () => void;
};

const GeneListTab = ({ text, isActive, onClick }: Props) => {
  const isMobile = useMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`, false);

  return (
    <div
      className={`z-10 font-bold cursor-pointer ${
        isMobile
          ? "p-[16px] text-[16px] leading-[16px]"
          : "py-[12px] px-[24px] text-[20px] leading-[20px]"
      } ${
        isActive ? "relative text-primary border-b-[3px] border-primary" : ""
      }`}
      onClick={onClick}
    >
      {text}
    </div>
  );
};

export default GeneListTab;
